import React, { useState, useEffect, useCallback } from "react";
import { Button, Grid, InputAdornment, IconButton } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import CustomTextField from "../../../../components/CustomTextField";
import { searchPayload } from "../../../../utils/common";
import CachedIcon from "@mui/icons-material/Cached";
import { useDispatch } from "react-redux";
import usePassword from "../../../../hooks/usePassword";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const LoginDetail = (props) => {
  const { getPassword, generatedPassword, hasError, errorMessage } = usePassword();

  const {
    register,
    formState: { errors },
    control,
    watch,
    reset,
    setValue,
  } = useFormContext();

  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  // let [searchParams, setSearchParams] = useSearchParams();

  const HoverIcon = styled(CachedIcon)(({ theme }) => ({
    transition: "transform 0.3s ease, color 0.3s ease",
    "&:hover": {
      transform: "rotate(90deg) scale(1.2)",
      color: theme.palette.primary.main,
    },
  }));

  const { t } = useTranslation();

  const { fields, tenantId } = props;

  console.log(fields, "fields");

  console.log(generatedPassword, "passssss");

  // useEffect(() => {
  //   console.log(officialEmailId, "dssssssssssssss");
  //   resetField("userName", { defaultValue: officialEmailId });
  // }, [officialEmailId]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev); // Toggle the password visibility
  };

  const generatePassword = async () => {
    const password = await getPassword();
    console.log("Generated Password:", password);
    setValue("password", password.password);
    setValue("confirmPassword", password.password);
  };

  return (
    <Grid container spacing={12} className="row" pt={8}>
      <Grid item md={6}>
        <CustomTextField
          label={t("user_name")}
          name="userName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
          // disabled={true}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          type={showPassword ? "password" : "text"}
          label="Password"
          name="password"
          control={control}
          fullWidth
          errors={errors}
          fields={fields}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={generatePassword}>
                  <HoverIcon />
                </IconButton>
                <IconButton
                  onClick={togglePasswordVisibility}
                  edge="end"
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          label={t("confirm_password")}
          name="confirmPassword"
          type="password"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
    </Grid>
  );
};

export default LoginDetail;
